import { useQueryClient } from '@tanstack/react-query'

import { CommentProps, Comments } from '@/components'

import { isSuperUser } from '@/helpers'
import {
  QUERIES_ADMIN,
  useOrderManagmentPurchaseOrderCommentCreate,
  useOrderManagmentPurchaseOrderCommentEdit,
  useOrderManagmentPurchaseOrderCommentRemove,
  useOrderManagmentPurchaseOrderCommentsList,
} from '@/services'

import { useAuth } from '@/providers'
import { SaleOrderCommentTypesEnum, SupplyOrderCommentTypesEnum } from '@/types'

import { TabCommentsProps } from './tab-comments.type'

import styles from './tab-comments.module.css'

export const TabComments = ({
  supplyOrderUuid,
  isLoading,
}: TabCommentsProps) => {
  const queryClient = useQueryClient()

  const { data, isLoading: isLoadingComments } =
    useOrderManagmentPurchaseOrderCommentsList(
      supplyOrderUuid,
      { ordering: '-createdAt' },
      !!supplyOrderUuid,
    )

  const { mutateAsync, isPending } =
    useOrderManagmentPurchaseOrderCommentCreate(supplyOrderUuid)

  const createComment = async (data: { comment: string }) => {
    return mutateAsync({ ...data, type: SaleOrderCommentTypesEnum.default })
  }

  const { mutateAsync: deleteComment } =
    useOrderManagmentPurchaseOrderCommentRemove(supplyOrderUuid || '')
  const { mutateAsync: updateComment } =
    useOrderManagmentPurchaseOrderCommentEdit(supplyOrderUuid || '')

  const { whoAmI } = useAuth()

  const hasPermissionToEditOrDelete = (
    item: CommentProps<SupplyOrderCommentTypesEnum>,
  ) =>
    (whoAmI?.email === item?.user?.email || isSuperUser(whoAmI?.email)) &&
    item?.type === SupplyOrderCommentTypesEnum.default

  const isLoadingAll = isLoading || isLoadingComments || isPending

  return (
    <div className={styles.container}>
      <Comments<SupplyOrderCommentTypesEnum>
        comments={data?.data?.results}
        createComment={createComment}
        deleteComment={deleteComment}
        updateComment={updateComment}
        hasPermissionToEditOrDelete={hasPermissionToEditOrDelete}
        isLoading={isLoadingAll}
        invalidateQueries={() =>
          queryClient.invalidateQueries({
            queryKey: [
              QUERIES_ADMIN.BFF_SUPPLIER_ORDER_MANAGMENT_PURCHASE_ORDER_COMMENTS
                .module,
            ],
          })
        }
      />
    </div>
  )
}
